"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateWithdraw = void 0;
var _react = _interopRequireDefault(require("react"));
var _state = require("../../../../../../state");
var _Context = require("./Context");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var CreateWithdraw = function CreateWithdraw(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_Context.Context.Provider, {
    value: {
      useCreateWithdraw: _state.useCreateWithdraw,
      useWithdrawFee: _state.useWithdrawFee
    }
  }, children);
};
exports.CreateWithdraw = CreateWithdraw;